// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const sortParameterValuesByBand = (initialparameterValues) => (dispatch, getState) => (

  getState().domain.getIn(['regulatorySettings', 'bands']).reduce((a, d) => {
    const bandParameter = initialparameterValues.find(dd => dd.bandId === d.get('bandId'))
    if(bandParameter) {
      a.push(bandParameter)
    }

    return a
  }, [])
)

export default sortParameterValuesByBand
